var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-center-modal side-center-modal-invite-audience"},[_c('div',{staticClass:"container-publish-template"},[_c('ShareToCommunity',{attrs:{"from":"presentation-detail","title":_vm.getShareToCommunityTitle,"presentation":_vm.presentation,"useInShareV2Modal":_vm.isTreatmentShareV2}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }